import React, { Component } from 'react';
import './App.css';

class App extends Component {
  state = {
    showScrollButton: false,
    isMenuOpen: false
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if (window.scrollY > 300) {
      if (!this.state.showScrollButton) this.setState({ showScrollButton: true });
    } else {
      if (this.state.showScrollButton) this.setState({ showScrollButton: false });
    }
  };

  toggleMenu = () => {
    this.setState(prevState => ({ isMenuOpen: !prevState.isMenuOpen }));
  };

  closeMenu = () => {
    this.setState({ isMenuOpen: false });
  };

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  render() {
    return (
      <div>
        <div className="navbar-wrapper">
          <nav className="navbar">
            <div className="navbar-top">
              <a href="#/" className="nav-logo nav-logo-special">
                ZT
              </a>
              <button 
                className={`hamburger ${this.state.isMenuOpen ? 'open' : ''}`} 
                onClick={this.toggleMenu} 
                aria-label="Menu"
              >
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
              </button>
            </div>
            <ul className={`nav-links ${this.state.isMenuOpen ? 'open' : ''}`}>
              <li><a href="#nabidka" onClick={this.closeMenu}>Služby</a></li>
              <li><a href="#kontakt" onClick={this.closeMenu}>Kontakt a otevírací doba</a></li>
            </ul>
          </nav>
        </div>

        <section className="hero-section">
          <div className="container">
            

            <div className="hero-content hero-animated">
              <div className="hero-subtitle">
                ZLATNICTVÍ TOBOLOVI
              </div>
              <h1 className="hero-title serif">
                Ruční výroba<br />
                šperků na míru
              </h1>
              <p className="hero-desc">
                Spojení tradičního řemesla a moderního designu. Tvoříme příběhy vtisknuté do drahých kovů.
              </p>
              
              <div style={{ marginTop: '40px' }}>
                <a href="#nabidka" className="btn-primary">Naše služby &rarr;</a>
              </div>
            </div>
          </div>
        </section>

        <section id="nabidka" className="services-section">
          <div className="container">
            <h2 className="section-title serif">Co nabízíme</h2>
            <p className="section-desc">Preciznost v každém detailu, od prvního návrhu až po finální lesk.</p>

            <div className="services-grid">
              
              <div className="service-card">
                <div className="service-card-header">
                  <div className="service-icon">
                    <svg viewBox="0 0 24 24"><path d="M21.71 20.29l-1.42 1.42a1 1 0 0 1-1.41 0L7 9.85A3.81 3.81 0 0 1 6 10a4 4 0 0 1-3.78-5.3l2.54 2.54.53-.53 1.41-1.41.53-.53L4.7 2.22A4 4 0 0 1 10 6a3.81 3.81 0 0 1-.15 1l11.86 11.88a1 1 0 0 1 0 1.41z"/></svg>
                  </div>
                  <h3 className="serif">Ruční výroba</h3>
                </div>
                <p>Šperky vyrábíme s pečlivostí a láskou v naší rodinné dílně. Zakládáme si na kvalitní a poctivé ruční práci.</p>
              </div>

              <div className="service-card">
                <div className="service-card-header">
                  <div className="service-icon">
                    <svg viewBox="0 0 24 24"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
                  </div>
                  <h3 className="serif">Zakázková výroba</h3>
                </div>
                <p>Máte vlastní představu? Společně navrhneme unikátní šperk, který bude odrážet vaši osobnost a vkus.</p>
              </div>

              <div className="service-card">
                <div className="service-card-header">
                  <div className="service-icon">
                    <svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-7.5c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg>
                  </div>
                  <h3 className="serif">Snubní a zásnubní prsteny</h3>
                </div>
                <p>Symboly vaší lásky v té nejčistší podobě. Od klasických linií po moderní designové kousky s drahými kameny.</p>
              </div>

              <div className="service-card">
                <div className="service-card-header">
                  <div className="service-icon">
                    <svg viewBox="0 0 24 24"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>
                  </div>
                  <h3 className="serif">Rytecké práce</h3>
                </div>
                <p>Personalizujte svůj šperk věnováním, datem nebo monogramem. Provádíme precizní rytiny do drahých kovů.</p>
              </div>

              <div className="service-card">
                <div className="service-card-header">
                  <div className="service-icon">
                    <svg viewBox="0 0 24 24"><path d="M21.71 7.29l-5-5a1 1 0 0 0-1.42 0l-3 3a1 1 0 0 0 0 1.42l1.29 1.29L4.29 17.29a1 1 0 0 0 0 1.42l1 1a1 1 0 0 0 1.42 0L16 10.41l1.29 1.29a1 1 0 0 0 1.42 0l3-3a1 1 0 0 0 0-1.41z"/></svg>
                  </div>
                  <h3 className="serif">Opravy a renovace</h3>
                </div>
                <p>Vrátíme vašim starším šperkům jejich původní krásu. Provádíme čištění, opravy zapínání i fasování kamenů.</p>
              </div>

              <div className="service-card">
                <div className="service-card-header">
                  <div className="service-icon">
                    <svg viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/></svg>
                  </div>
                  <h3 className="serif">Flexibilní domluva</h3>
                </div>
                <p>Víme, že máte napilno. Po předchozí domluvě nás můžete navštívit na pobočce i mimo naši standardní otevírací dobu.</p>
              </div>

            </div>
          </div>
        </section>

        <section id="kontakt" className="location-section">
          <div className="container location-grid">
            <div className="location-content">
              <h2 className="serif">Kde nás najdete</h2>
              <p>
                Navštivte nás v Praskačce. Rádi vám ukážeme naši práci naživo nebo s vámi probereme vaši vizi.
              </p>
              
              <div className="contact-blocks">
                <div className="contact-block">
                  <h4>Kontakt</h4>
                  <ul>
                    <li style={{ display: 'flex', alignItems: 'center' }}>
                      <svg viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
                      <a href="tel:+420736534140" style={{ marginRight: '10px' }}>+420 736 534 140</a>
                      <a href="https://wa.me/420736534140" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', color: '#25D366', fontWeight: 500, fontSize: '0.85rem' }} title="Napsat na WhatsApp">
                        <svg viewBox="0 0 24 24" style={{ width: '16px', height: '16px', fill: 'currentColor', margin: '0 4px 0 0' }}><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/></svg>
                        WhatsApp
                      </a>
                    </li>
                    <li>
                      <svg viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
                      <a href="tel:+420736534239">+420 736 534 239</a>
                    </li>
                    <li>
                      <svg viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
                      <a href="mailto:zlatnictvi@tobolovi.com">zlatnictvi@tobolovi.com</a>
                    </li>
                    <li>
                      <svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
                      Praskačka 82, 503 33 Praskačka
                    </li>
                  </ul>
                </div>

                <div className="contact-block">
                  <h4>Otevírací doba</h4>
                  <ul>
                    <li style={{justifyContent: 'space-between', width: '100%'}}>
                      <span>Pondělí - Čtvrtek</span>
                      <strong>9:00 - 12:00<br/>13:00 - 17:00</strong>
                    </li>
                    <li style={{justifyContent: 'space-between', width: '100%'}}>
                      <span>Pátek, Sobota, Neděle</span>
                      <strong>Zavřeno</strong>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="map-wrapper">
              <iframe 
                title="Mapa Zlatnictví Tobolovi"
                src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2555.2489017820244!2d15.737345915856707!3d50.17518241504163!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470c2c6f3996c921%3A0x194e6e39f7ce4a02!2sPraska%C4%8Dka+82%2C+503+33+Praska%C4%8Dka!5e0!3m2!1scs!2scz!4v1547390433478`} 
                frameBorder="0" 
                allowFullScreen>
              </iframe>
            </div>
          </div>
        </section>

        <footer className="footer">
          <div className="container">
            <div className="footer-bottom">
              <div>&copy; {new Date().getFullYear()} Zlatnictví Tobolovi. Všechna práva vyhrazena.</div>
            </div>
          </div>
        </footer>

        {this.state.showScrollButton && (
          <button className="scroll-to-top" onClick={this.scrollToTop} aria-label="Nahoru">
            <svg viewBox="0 0 24 24"><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/></svg>
          </button>
        )}
      </div>
    );
  }
}

export default App;
